module.exports = __webpack_public_path__ + "c6739f8a.svg";